import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PageTitle } from '../../components'
import { replace } from '../../actions/nav-actions'

class Dashboard extends Component {
    componentWillMount() {
        this.props.replace('/organizations')
    }
    render() {
        return (
            <div>
                <PageTitle title="Dashboard" />
            </div>
        )
    }
}

const mapStateToProps = s => ({

});

const mapDispatchToProps = d => ({
    replace(routeName) {
        d(replace(routeName));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/routers/Dashboard/index.js